import React, { useContext, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Container, Form, Checkbox } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';
import { AuthContext } from '../../../Context/AuthContext';
import { DataPrivacy, PageTitle } from '../../Reusable/Elements';
import { SubmitButton } from '../../Reusable/Buttons';
import useUpdateProfile from '../../../Hooks/Profile/useUpdateProfile';
import { StateContext } from '../../../Context/StateContext';

const AcceptTerms = () => {
    
    const { t } = useTranslation();
    const history = useHistory();

    const [ acceptTerms, setAcceptTerms ] = useState(false);
    const { userProfile } = useContext(AuthContext);
    const { updateProfile } = useUpdateProfile();
    const { globalState } = useContext(StateContext);

    // Save user
    const onSubmit = async () => {
        
        try {
            const termsAccepted = new Date().toISOString();

            const profile = {
                "id": userProfile.id,
                "firstName": userProfile.firstName,
                "lastName": userProfile.lastName,
                "emailAddress": userProfile.email,
                "termsAccepted": acceptTerms ? termsAccepted : null
            }

            const result = await updateProfile(profile);

            if (result.status === 200) {
                globalState.setTermsAccepted(termsAccepted);
                return history.push("/");
            }

        } catch (error) {
        }

    }

    return (
        <Form className="accept-terms" onSubmit={(ev) => onSubmit(ev)} >
            
            {/* Title */}
            <PageTitle title={t('acceptTerms.title')} hideInfo/>
            <p>{t("acceptTerms.description")}</p>

            {/* Accept terms */}
            <Form.Field
                required
                control={Checkbox}
                label={t('acceptTerms.checkbox')}
                placeholder={'Checkbox'}
                checked={acceptTerms}
                onChange={(ev, {checked}) => setAcceptTerms(checked) }
                id="accept-terms"
            />

            {/* DataPrivacy */}
            <DataPrivacy className="green" />

            <Container textAlign="right">
                <SubmitButton icon="save" color="green" title={t('general.confirm')} disabled={!acceptTerms}/>
            </Container>
        </Form>
    );
}

export default AcceptTerms;